import type { FC } from "react";

import { DropdownBoundTemplate } from "@ryde/controls";
import type { IDropdownItem, IDropdownItemStations } from "@ryde/shared";

import { useBookingHomeStationDropdown } from "../hooks";

interface IBookingHomeStationDropdownProps {
  name: string;
  formLabel: string;
  homeStations: IDropdownItemStations[];
  addedStationIds: number[];
  onStationQuickAdded: (stationId: number) => void;
  onSelect?: (item?: IDropdownItem) => void;
  disabled: boolean;
}

/** The passenger's home side of a booking, with the same quick-add for a missing station as the passenger's home address. */
export const BookingHomeStationDropdown: FC<
  IBookingHomeStationDropdownProps
> = ({
  name,
  formLabel,
  homeStations,
  addedStationIds,
  onStationQuickAdded,
  onSelect,
  disabled,
}) => {
  const { isHomeStationOptionShown, dropdownItemsReloadKey } =
    useBookingHomeStationDropdown({
      name,
      homeStations,
      addedStationIds,
    });

  return (
    <DropdownBoundTemplate
      name={name}
      formLabel={formLabel}
      formAttributes={{
        dropItemsSource: "station",
        dropItemsDisableAdd: true,
        hideDropdownEditButton: true,
        // Keeps the order of the sibling station dropdowns, which list stations as fetched.
        disableSorting: true,
        disabled,
        customDropdownItemsFilter: isHomeStationOptionShown,
        dropdownItemsReloadKey,
        onStationQuickAdded,
      }}
      onSelect={onSelect}
    />
  );
};
